import React from "react";
import PropTypes from "prop-types";
import ProductTag from '../../ui/ProductTag.jsx';
import { PRODUCT_CONFIG } from '../../../config/currency.js';

/**
 * ProductTags Molecule - Displays a list of product tags
 * @component
 * @example
 * <ProductTags
 *   categories={['electronics', 'gadgets', 'tech']}
 *   onTagClick={(productId, tag) => console.log(tag)}
 *   productId="123"
 * />
 */
const ProductTags = ({
    categories = [],
    onTagClick,
    productId,
    variant = "",
    sliceStart = PRODUCT_CONFIG.TAG_SLICE_START,
    sliceEnd = PRODUCT_CONFIG.TAG_SLICE_END,
    className = "",
}) => {
    if (!categories || categories.length === 0) {
        return null;
    }

    const displayTags = categories.slice(sliceStart, sliceEnd);

    return (
        <div className={`flex flex-wrap mx-2 mb-4 ${className}`}>
            {displayTags.map((tag, index) => (
                <ProductTag
                    key={index}
                    tag={tag}
                    variant={variant}
                    onClick={() => onTagClick?.(productId, tag, index + sliceStart)}
                />
            ))}
        </div>
    );
};

ProductTags.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.string),
    onTagClick: PropTypes.func,
    productId: PropTypes.string,
    variant: PropTypes.string,
    sliceStart: PropTypes.number,
    sliceEnd: PropTypes.number,
    className: PropTypes.string,
};

export default ProductTags;
